import FingerPrintUtil from './FingerprintUtil';

let DEVICE_FINGER_PRINT = '';
const PersistentLoginUtil = {
  setBeforeRequestHeader(xhr) {
    xhr.setRequestHeader('X-Macys-DeviceFingerPrint', DEVICE_FINGER_PRINT);
  },

  setHeader(headers) {
    let headerObject = {};
    if (headers) {
      headers['X-Macys-DeviceFingerPrint'] = DEVICE_FINGER_PRINT;
    } else {
      headerObject = {
        'X-Macys-DeviceFingerPrint': DEVICE_FINGER_PRINT,
      };
    }
    return headerObject;
  },

  generateFingerPrint(pattern) {
    return FingerPrintUtil.getFPforCustomParams(pattern || '2,7,14,15,16', false);
  },

  setDeviceFingerPrint(pattern) {
    const deviceFingerPrint = this.generateFingerPrint(pattern);
    DEVICE_FINGER_PRINT = deviceFingerPrint;
  },
};
module.exports = PersistentLoginUtil;
